import { createSlice } from "@reduxjs/toolkit";
import { FaBuilding, FaDollarSign, FaMoneyBill, FaPrint } from "react-icons/fa";
import { FaIntercom } from "react-icons/fa";
const accounting = '/assets/images/services/accounting.jpg';
const telecom = '/assets/images/services/telecom.jpg';
const agriculture = '/assets/images/services/agriculture.jpg';
const construction = '/assets/images/services/construction.jpg';
const contract = '/assets/images/services/contract.jpg';
const crude = '/assets/images/services/crude.jpg';
const propertyDev = '/assets/images/services/propertyDev.jpg';
let photography = '/assets/images/services/photography.jpg';

export const servicesSlice = createSlice({
    name: 'services',

    initialState: {

        payload: [
            {
                // "icon": <FaDollarSign size={50} style={{ borderRadius: '100%', width: '30px', height: '30px' }}/>,
                'icon': accounting,
                "title": "Accounting and Finance",
                "description": "Description of Accounting and financing services offered by ABAAFASHAB. Description of Accounting and financing services offered by ABAAFASHAB."
            },
              {
                // "icon": <FaIntercom size={50} style={{ borderRadius: '100%', width: '30px', height: '30px' }} />,
                'icon': telecom,
                "title": "TeleCommunication Services",
                "description": "Description of Telecommunication services offered by ABAAFASHAB. Description of Telecommunication services offered by ABAAFASHAB."
            },
              {
                "icon": photography,
                "title": "PHOTOGRAPHY AND PRINTING",
                "description": "Description of Photography and printing services offered by ABAAFASHAB."
            },
              {
                // "icon": <FaBuilding size={50} style={{ borderRadius: '100%', width: '30px', height: '30px' }} />,
                'icon': propertyDev,
                "title": "PROPERTY DEVELOPMENT",
                "description": "Description of property development services offered by ABAAFASHAB."
             },
              {
                // "icon": <FaBuilding size={50} style={{ borderRadius: '100%', width: '30px', height: '30px' }} />,
                'icon': construction,
                "title": "CONSTRUCTION ENGINEERING AND ENVIRONMENTAL SERVICES ",
                "description": "Description of construction and enviromental services offered by ABAAFASHAB."
             },
              {
                'icon': agriculture,
                "title": "AGRICULTURE", 
                "description": "Description of Agricultural services offered by ABAAFASHAB."
            },
              {
                'icon': crude,
                "title": "CRUDE OIL", 
                "description": "Description of the kind of crude oil services offered by ABAAFASHAB."
            },
              {
                'icon': contract,
                "title": "CONTRACTING AND GENERAL BUSINESS",
                "description": "Description of contracting and business services offered by ABAAFASHAB. Description of contracting and business services offered by ABAAFASHAB."
            }
        ]
    },
    reducers: {
        services: (state, action) => {
           state.payload = action.payload
        },
    }
});

export const {services} = servicesSlice.actions
export default servicesSlice.reducer